import React, { FC } from 'react';

import Progress from '../components/Progress';

interface PriorityProps {
  endSpacing?: boolean;
  height?: string;
  priority?: number;
}

const PriorityDetail: FC<PriorityProps> = ({ endSpacing, height, priority }) => {
  if (!priority) {
    return null;
  }

  return <Progress endSpacing={endSpacing} height={height} max={100} min={0} value={priority} />;
};

export default PriorityDetail;
